import { json } from "react-router-dom";
import { baseUrl_SPB} from '../BaseUrl';
const API_BASE = 'http://localhost:8080'; // Update this as needed

export const fetchPayruns = async (companyId, dateFrom, dateTo,token) => {
    try {
        const response =  await fetch(`${baseUrl_SPB}/api/v1/payrun/getpayrunsallbycompanyid?companyId=${companyId}`, {
            method: 'GET',

            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            },

        });

        const jsonResponse = await response.json();
        console.log(jsonResponse);
        return jsonResponse;

    } catch (error) {
        console.error('Error:', error);
    }
 
  
  
};

export const fetchPayrunById = async (id,token) => {
try {
        const response =  await fetch(`${baseUrl_SPB}/api/v1/payrun/getpayrunsbyid?id=${id}`, {
            method: 'GET',

            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            },

        });

        const jsonResponse = await response.json();
        return jsonResponse;

    } catch (error) {
        console.error('Error:', error);
    }
 
};


export const triggerPayRun = async (companyId,dateFrom,dateTo,payDate,token) => {
    console.log(token);
try {
        const response =  await fetch(`${baseUrl_SPB}/api/v1/payrun/triggerpayrun?companyId=${companyId}&dateFrom=${dateFrom}&dateTo=${dateTo}`, {
            method: 'GET',

            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            },

        });

        const jsonResponse = await response.json();
        return jsonResponse;

    } catch (error) {
        console.error('Error:', error);
    }
 
};

export const updatePayrun = async (payrun,token) => {
  const response = await fetch(`${baseUrl_SPB}/api/v1/payrun/paid`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
     },
    body: JSON.stringify(payrun)
  });
  return response.json();
};

export const emailPayslip = async (payrun,token) => {
  const response = await fetch(`${baseUrl_SPB}/api/v1/payslip/emailpdf/${payrun.id}/${payrun.staffEmail}/${payrun.companyId}`, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
     },
    
  });
  return response.json();
};
